module.exports = "//static.hsappstatic.net/academy-public-ui/static-1.7342/images/learningPaths-card-thumbnail.webp"